import {
  Component,
  OnInit,
  ViewChild,
  Input
} from '@angular/core';
import {
  BookResult
} from 'src/app/models/api_models/book';
import {
  MatPaginator,
  PageEvent
} from '@angular/material/paginator';
import {
  MatTableDataSource
} from '@angular/material/table';
import {
  MatSort
} from '@angular/material/sort';
import {
  $
} from 'protractor';

@Component({
  selector: 'app-book-table',
  templateUrl: './book-table.component.html',
  styleUrls: ['./book-table.component.scss']
})
export class BookTableComponent implements OnInit {




  public isLoad = false

  length = 0;
  CurrentIdx = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 200];

  public displayBookList: BookResult[] = null;
  private _bookList: BookResult[] = null;
  get bookList(): BookResult[] {
    return this._bookList;
  }

  pageEvent: PageEvent;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }
  propertiesChange($event: any) {
    let tmp = [...this._bookList];
    this.pageEvent = $event;
    this.displayBookList = new Array();
    if (this.pageEvent !== undefined) {
      this.pageSize = $event.pageSize;
      this.CurrentIdx = (this.pageEvent.pageIndex ) * this.pageSize;
      this.displayBookList = tmp.splice(this.CurrentIdx, (this.pageSize));
    } else
      this.displayBookList = tmp.splice(this.CurrentIdx, this.pageSize);
  }

  @Input()
  set bookList(bookList: BookResult[]) {
    this._bookList = bookList;
    if (this._bookList !== null) {
      this.isLoad = true;
      this.length = this._bookList.length;
      let tmp = [...this._bookList];
      this.displayBookList = null;
      if (this.pageEvent !== undefined) {
        this.CurrentIdx = (this.pageEvent.pageIndex ) * this.pageSize;
        this.displayBookList = tmp.splice(this.CurrentIdx, (this.CurrentIdx + this.pageSize));
      } else
        this.displayBookList = tmp.splice(this.CurrentIdx, this.pageSize);
    }
  }



// getDateFormat(str : string){
//   var newString = str.replace('-','/').replace('-', '/').replace('T',' ').replace(':00Z','');
//  return  newString
// }


getDateFormat(str: string) {
  const clean = str.replace('T', ' ').replace('Z', '');

  const [datePart, timePart] = clean.split(' ');
  const [year, month, day] = datePart.split('-');

  return `${day}/${month}/${year} ${timePart.substring(0,5)}`;
}






  constructor() {


  }

  ngOnInit() {

  }
}